import React, {  useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import FilterSelect from '../../../components/TableFilter/ColumnsFilters/FilterSelect';
import { useDispatch, useSelector } from 'react-redux';
import { contingentModule, exportFincenterZIP, loadFincenterDocuments } from '../ContingentDucks';
import StaticTablePagination from '../../../_ui/Table/StaticTablePaginated';
import { exportReportFincenterColumns } from '../../../components/PageReport/ExportReportFincenterColumns';
import useTableFilter from '../../../components/TableFilter/useTableFilter';

const REPORT_TYPES = [
  { id: 'FINCENTER_PLANNED_REPORT', type: 'FINCENTER_PLANNED_REPORT', label: 'contingentPage_planned' },
  { id: 'FINCENTER_ACTUAL_REPORT', type: 'FINCENTER_ACTUAL_REPORT', label: 'contingentPage_actual' },
];

const REPORT_STATUSES = [
  { id: 'SENT', value: 'SENT', label: 'contingentPage_statusSent' },
  { id: 'FAILED', value: 'FAILED', label: 'contingentPage_statusFailed' },
];

export default function ContingentExportReportModal({ isOpen, close }) {
  const { t, i18n } = useTranslation();
  const [reportType, setReportType] = useState('FINCENTER_PLANNED_REPORT');
  const [statusType, setStatusType] = useState('SENT');
  const dispatch = useDispatch();
  const { finCenterDocuments, loadingFinCenterDocuments } = useSelector(state => state[contingentModule]);

  const handleDownloadZip = (documentId, fileName) => {
    dispatch(exportFincenterZIP(documentId,fileName));
  };

  const { nextPage, changeFilter } = useTableFilter(
    filter => dispatch(loadFincenterDocuments(filter)),
    {
      pageNumber: 1,
      pageSize: 10,
      status: statusType,
      type: reportType,
    },
    'modal'
  );

  const handleReportTypeChange = (e) => {
    const newReportType = e.target.value;
    setReportType(newReportType);
    changeFilter({ type: newReportType, pageNumber: 1 });
  };

  const handleStatusTypeChange = (e) => {
    const newStatusType = e.target.value;
    setStatusType(newStatusType);
    changeFilter({ status: newStatusType, pageNumber: 1 });
  };

  return (
    <Dialog open={isOpen} onClose={close} maxWidth="md" fullWidth>
      <DialogTitle>{t('contingentPage_exportTabel_btn')}</DialogTitle>
      <DialogContent dividers>
        <div style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <Typography>{t('contingentPage_reportType')}</Typography>
            <FilterSelect
              name="type"
              options={REPORT_TYPES.map(item => ({
                code: item.type,
                ru_name: t(item.label),
                kk_name: t(item.label),
              }))}
              value={reportType}
              onChange={handleReportTypeChange}
              fullWidth={false}
              style={{ width: 200 }}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <Typography>{t('contingentPage_status')}</Typography>
            <FilterSelect
              name="status"
              options={REPORT_STATUSES.map(item => ({
                code: item.value,
                ru_name: t(item.label),
                kk_name: t(item.label),
              }))}
              value={statusType}
              onChange={handleStatusTypeChange}
              fullWidth={false}
              style={{ width: 200 }}
            />
          </div>
        </div>
        <div style={{marginTop:"50px"}}>
          <StaticTablePagination
            columns={exportReportFincenterColumns({ t, lang: i18n.language, onDownloadZip: handleDownloadZip })}
            data={finCenterDocuments.content}
            sortable={false}
            totalElements={finCenterDocuments.totalElements}
            loading={loadingFinCenterDocuments}
            onClickLoadMore={() => nextPage()}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="secondary">
          {t('contingentPage_cancelBtn')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}